module.exports = __webpack_public_path__ + "img/IMG_6964.e3012f6d.webp";